import { Box } from '@chakra-ui/react';
import React from 'react';
import { useTeamChangeReset } from 'core/hooks/useTeamChangeReset';
import { ANALYTICS_V3_PATH } from 'views/main/routes/routes';
import { resetAnalyticsV3FiltersAndPagination } from './helpers';
import Layout from './components/layout';
import Providers from './components/providers';

function AnalyticsV3() {
  useTeamChangeReset({
    path: ANALYTICS_V3_PATH,
    resetFn: resetAnalyticsV3FiltersAndPagination,
  });

  return (
    <Providers>
      <Box>
        <Layout />
      </Box>
    </Providers>
  );
}

export default AnalyticsV3;
